import { GridLayoutElement } from 'adapter/in/dashboards/components/generic/ReactGrid';
import {
    NEW_WIDGET_MIN_HEIGHT,
    NEW_WIDGET_MIN_WIDTH,
    WidgetCoordinates,
} from 'adapter/in/dashboards/components/Grid/newWidgetOverlayUtils';
import { COLUMNS } from 'adapter/in/dashboards/components/Grid/constants';
import { LayoutElementType, LayoutType } from 'domain/entity/layout';

export const LOCAL_TEXT_BLOCK_ID_PREFIX = '__local_text_block__';

export const createLocalTextBlockId = (): string => `${LOCAL_TEXT_BLOCK_ID_PREFIX}${Date.now()}_${Math.random().toString(36).slice(2)}`;

export const isLocalTextBlockId = (id?: string | null): boolean => !!id?.startsWith(LOCAL_TEXT_BLOCK_ID_PREFIX);

export const createLocalTextBlockGridElement = (coordinates: WidgetCoordinates): GridLayoutElement => ({
    i: createLocalTextBlockId(),
    x: coordinates.x,
    y: coordinates.y,
    w: coordinates.w,
    h: coordinates.h,
    static: false,
    type: LayoutElementType.RICH_TEXT,
    minWidth: NEW_WIDGET_MIN_WIDTH,
    maxWidth: COLUMNS[LayoutType.A4],
    minHeight: NEW_WIDGET_MIN_HEIGHT,
    maxHeight: COLUMNS[LayoutType.A4],
});
